import ModuleBase from "../../../../framework/core/mvvm/module_base";
import PokerTableFrameView from "./poker_table_frame_view";
import { IPokerFrameData } from "./poker_table_frame_interface_data";
import TimeManager from "../../../../manager/time_manager";
import Utility from "../../../../utility/utility";
import ModuleManager from "../../../../framework/core/module_manager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PokerTableFrame extends ModuleBase<PokerTableFrameView, null>  {

    protected intentData: IPokerFrameData = null

    protected m_lastRefreshTime = 0


    protected _rankUsers = []

    constructor(){
        super()
        this.initModule(null, null, null)
    }

    resetModule(){
        super.resetModule()
        this.unBindUiBtnEventListener()
    }

    initModule(viewType, modelType, resPath){           
        this.windowPrefabResPath = resPath? resPath: 'package/public/poker/tableframe/PokerTableFrame'
        this.viewType = viewType? viewType: PokerTableFrameView
        this.modelType = modelType
    }

    onInit() {
        this.bindUiBtnEventListener()
    }

    protected bindUiBtnEventListener(){
        this.view.nodeMask.on("click", this.onClickCloseBtn, this)
        this.view.nodeCloseBtn.on("click", this.onClickCloseBtn, this)
        this.view.nodeOpenBtn.on("click", this.onClickOpenBtn, this)
        this.view.nodeLeaveBtn.on("click", this.onClickLeaveBtn, this)
        this.view.nodeFreeRoomBtn.on("click", this.onClickFreeRoomBtn, this)
        this.view.nodeSettingBtn.on("click", this.onClickSettingBtn, this)
        this.view.nodeRuleBtn.on("click", this.onClickRuleBtn, this)
        this.view.nodeRuleExplainBtn.on("click", this.onClickRuleExplainBtn, this)
        this.view.nodeIntrustBtn.on("click", this.onClickIntrustBtn, this)
        this.view.tableRankBtnNode.on("click", this.onClickMatchRankBtn, this)
    }

    protected unBindUiBtnEventListener(){
        this.view.nodeMask.targetOff(this)
        this.view.nodeCloseBtn.targetOff(this)
        this.view.nodeOpenBtn.targetOff(this)
        this.view.nodeLeaveBtn.targetOff(this)
        this.view.nodeFreeRoomBtn.targetOff(this)
        this.view.nodeSettingBtn.targetOff(this)
        this.view.nodeRuleBtn.targetOff(this)
        this.view.nodeRuleExplainBtn.targetOff(this)
        this.view.nodeIntrustBtn.targetOff(this)
    }

    onShow(intentData?: IPokerFrameData) {
        super.onShow(intentData)        
        this.refreshView(intentData)
        this.view.showOpenBtn(true)
        this.view.showMenu(false)
        this.view.showCloseBtn(false)
    }

    refreshView(intentData?: IPokerFrameData){
        this.intentData = intentData
        this.view.showFreeRoomBtn(intentData.showFreeRoomBtn?true: false)
        this.view.showLeaveBtn(intentData.showLeaveBtn?true: false)
        this.view.showIntrustBtn(intentData.showIntrustBtn?true: false)
        this.view.showSettingBtn(intentData.showSettingBtn?true: false)
        this.view.showRuleBtn(intentData.showRuleBtn?true: false)    
        this.view.showRoomInfo(intentData.showRoomInfo?true: false, intentData.roomId)
        this.view.showTime(intentData.showTime?true: false)
    }

    showMatchInfo(show: boolean, matchData, CurLoopNo, rankUsers, myRank: number, playerCounts: number){
        let self = this
        let func = function(){
            if(show){
                if (matchData.matchRule == 2) {//晋级规则(1-积分制 2-排位制)                    
                    self.view.myMatchRankLabel.string = "<color=F6DE36>" + myRank + "</color>/" + playerCounts
                    let dif = matchData.matchRuleConfig.maxWheels - CurLoopNo
                    if (dif >= 1) {
                        self.view.kickOutLabel.string = "剩余" + dif + "轮比赛结束"
                    } else {
                        self.view.kickOutLabel.string = "    本轮比赛结束"
                    }
                }
            }
            self.view.myMatchInfoRoot.active = show || false
        }
        if (self.view) {
            func()
        }else{
            self.AddHandleToWaitDealQueue(func, null)
        }
        self._rankUsers = rankUsers       
    }

    on_destroy() {
        this.unBindUiBtnEventListener()
    }

    update(dt){
        if(this.view && this.intentData && this.intentData.showTime){
            if(this.m_lastRefreshTime + 1 < TimeManager.instance.AppRunningTime){
                this.m_lastRefreshTime = TimeManager.instance.AppRunningTime
                this.view.refreshTime()
            }            
        }
    }

    protected onClickCloseBtn(){
        this.playBtnSound()
        this.view.showMenu(false)
        this.view.showCloseBtn(false)
        this.view.showOpenBtn(true)
    }

    protected onClickOpenBtn(){
        this.playBtnSound()
        this.view.showMenu(true)
        this.view.showCloseBtn(true)
        this.view.showOpenBtn(false)
    }
    protected onClickLeaveBtn(){
        this.playBtnSound()
        let callback = this.intentData.clickLeaveBtnCallback
        if(callback){
            callback()
        }
    }
    protected onClickFreeRoomBtn(){
        this.playBtnSound()
        let callback = this.intentData.clickFreeRoomBtnCallback
        if(callback){
            callback()
        }
    }
    protected onClickSettingBtn(){
        this.playBtnSound()
        let callback = this.intentData.clickSettingBtnCallback
        if(callback){
            callback()
        }else{
            ModuleManager.instance.showModuleName("Setting");
        }
    }
    protected onClickIntrustBtn(){
        this.playBtnSound()
        let callback = this.intentData.clickIntrustBtnCallback
        if(callback){
            callback()
        }
    }

    protected onClickMatchRankBtn(){
        let self = this
        if (self._rankUsers.length > 0) {
            ModuleManager.instance.showModule(MatchRank, self._rankUsers)
        }
    }

    protected onClickRuleBtn(){
        this.playBtnSound()
        let callback = this.intentData.clickRuleBtnCallback
        if(callback){
            callback()
        }
    }
    protected onClickRuleExplainBtn(){
        let callback = this.intentData.clickRuleExplainBtnCallback
        if(callback){
            callback()
        }
    }

    protected playBtnSound(){
        Utility.playButtonSound()
    }
}
